(async () => {
  const el = document.getElementById('legal-case-index')

  if (!el) {
    return
  }

  const { default: clientRender } = (await import(/* webpackMode: 'eager' */ 'vue-compiler/clientRender'))

  const components = [
    {
      el,
      componentImport: () => import(/* webpackMode: 'eager' */ 'src/pages/info/legal-case/index.vue'),
    },
  ]

  await clientRender({ components })
})()
